import { get } from "react-hook-form";
import { useTaskListContext } from "../context/taskListContext";
import type { RootAsset } from "../models/RootAsset";
import { GetTaskListByArea } from "../repositorie/TaskListRepositorie";

type Props = {
	setIsTaskListLoading: (isLoading: boolean) => void;
	setTaskListError: (err: string) => void;
};

export const useSearchData = ({
	setIsTaskListLoading,
	setTaskListError,
}: Props) => {
	const {
		state: { craftSearchId, typeCode, searchText, downHours, assetSearchId },
		actions: {
			setAreasNumber,
			setAllRows,
			setListRootAssets,
			setRootAssetsDataTables,
		},
	} = useTaskListContext();

	return async () => {
		setIsTaskListLoading(true);
		const res = await GetTaskListByArea(
			craftSearchId,
			typeCode,
			searchText,
			downHours,
			assetSearchId,
		);
		if (res.ok) {
			const data: any = [];
			const areasSource = get(res, "data.tables[1].rows", []);
			const rowsSource = get(res, "data.tables[0].rows", []);

			setAreasNumber(areasSource.length);
			setListRootAssets(areasSource);
			setAllRows(rowsSource);

			areasSource.forEach((rootAsset: RootAsset) => {
				const dataToRootAssetList = rowsSource.filter(
					(obj: any) => obj.RootAssetId === rootAsset.RootAssetId,
				);
				data.push({
					rows: dataToRootAssetList,
					rootAssetName: rootAsset.TableName,
					rootAssetId: rootAsset.RootAssetId,
				});
			});
			setRootAssetsDataTables(data);
			setIsTaskListLoading(false);
		} else {
			setIsTaskListLoading(false);
			setTaskListError(res.message);
		}
	};
};
